import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Swot Widget
 */
@Component({
  selector: 'swot-widget',
  templateUrl: './swot-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './swot-widget.component.scss']
})
export class SwotWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Strengths text area options
   */
  strengthsTextAreaOptions: any = null;

  /**
   * Weaknesses text area options
   */
  weaknessesTextAreaOptions: any = null;

  /**
   * Opportunities text area options
   */
  opportunitiesTextAreaOptions: any = null;

  /**
   * Threats text area options
   */
  threatsTextAreaOptions: any = null;

    /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'swot', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('swot').pipe(take(1));
    
    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('swot', this.getReport()).pipe();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler('swot', this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    this.setDirtyFlag(false);
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Clamp text
   * @param e {any} Event object
   */
  public clampText(e) {
    e.srcElement.scrollTop = 0;
    e.srcElement.scrollLeft = 0;
  }


  /**
   * Data changed
   */
  public dataChanged(): void {
    this.setDirtyFlag(true);

    // setNewValue might be called by HashtagDirective in the middle of Angular change detection
    // so inform Angular to run additional detection cycle after we modify displayed data
    this.ref.detectChanges();
  }
}
